import React, {useEffect, useState} from 'react';

import {useHistory} from "react-router-dom";
import {callApi, callEmptyParamsApi} from "../../../connection/ClientApi";

import Urls from "../../../connection/Urls";

import messages from "res/messages/farsi";

import EmptyBox from "components/emptyBox/EmptyBox";
import Pagination from "components/list/Pagination";

import queryString from "query-string";

import Ticket from "./Ticket";
import TitleAddHeader from "../address/TitleAddHeader";

import ICAddIcon from "res/images/add.png";
import ICSupport from "res/images/empty_box.png";

export default function Suggestion(props) {

    const urlParams = queryString.parse(props.location.search);
    const history = useHistory();
    const [tickets,setTickets]=useState([]);
    const [showEmptyBox, setShowEmptyBox] = useState(false);
    const [pages, setPages] = useState([]);
    const [refreshMe, setRefreshMe] = useState(false);
    const [limit] = useState(15);

    const requestTickets=()=>{
        let params = new FormData();
        params.append("limit", limit);
        params.append("page", (urlParams && urlParams.p) ? urlParams.p : 1)
        callApi(Urls.getAllTicket, params, (data) => {
            if (data && data.list && data.list.length > 0) {
                setTickets(data.list);
                setShowEmptyBox(false);
                requestTicketsCount()
            } else {
                setTickets([])
                setShowEmptyBox(true)
            }

        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    const requestTicketsCount =()=>{

        callEmptyParamsApi(Urls.getTicketsCount, (data) => {
            let number = data.count / limit;

            if (data.count % limit > 0) {
                number++
            }

            let tempPages = []
            for (let i = 1; i <= number; i++) {
                tempPages.push({
                    number: i,
                    selected: i === parseInt(urlParams.p)
                })
            }

            setPages(tempPages)
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    useEffect(() => {
        requestTickets()
        requestTicketsCount()

    }, [props.location.search, refreshMe])
    const pushToHistory =(p)=>{
        props.onNavigate(history, '/suggestion?p=' + p)
    }

    const onNumberClick =(number)=>{
        pushToHistory(number)
    }
    const onNextClick=()=>{
        pushToHistory( (parseInt(urlParams.p) + 1))
    }
    const onBackClick=()=>{
        pushToHistory((parseInt(urlParams.p) - 1))
    }

    return (<>
            <div className="marginTopBottomSmall responseMain" >
                <TitleAddHeader
                    icon={ICAddIcon}
                    title={messages.tickets}
                    onIconClick={() => {
                         props.onNavigate(history,
                            '/addTicket')
                    }}/>
            </div>

                <div className="wInLPT100_wInFMS95 marginLeftRightSmall fullWidth">
                    {showEmptyBox ?
                        <div className="marginTopBottomMedium">
                            <EmptyBox message={messages.ticketListEmpty} showImage={ICSupport}/>
                        </div> :
                        <div >
                            <div>
                                <div  className="horizontalFullScreen responsiveTicketsPareentCards">
                                    {tickets.map((ticket, index) => {
                                        return (
                                            <Ticket
                                                {...props}
                                                key={index}
                                                ticket={ticket}
                                                orderStatusId={urlParams.s}
                                                page={urlParams.p}
                                                ticketImages={ticket.images.split(',')}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                            {(tickets.length > 0 && pages.length > 1) &&
                                <div style={{float: "left"}}>
                                    <br/>
                                    <Pagination
                                        pages={pages}
                                        onNumberClick={onNumberClick}
                                        onNextClick={onNextClick}
                                        onBackClick={onBackClick}/>

                                </div>
                            }

                        </div>
                    }
                </div>

    </>)

}